import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { name, year } from "../Constant";
import logodashheader from "../Assets/logo-dash-header.png";
import MenuIcon from "../Assets/menu.png";
import userIcon from "../Assets/userIcon.webp";
import {
  RedirectIfLogin,
  getSession,
  UpdateState,
  getState,
  handleSubmit,
  BreedForm,
  AlertMessage,
  AlertMessageOut,
  serializeArray,
  toggleDarkMode,
  toggleDarkModeX,
} from "./function";
import $ from "jquery";
import Head from "./head";

const doPreLogout = (elem) => {
  if (
    window.confirm(
      "Are you sure you want to Logout from " + name + " right now?"
    )
  ) {
    handleSubmit(elem, "logout");
  }
};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userID: "",
      password: "",
      message: "",
    };
  }

  componentDidMount() {
    toggleDarkMode();
    $(function () {
      let profile = document.querySelector(".profile");
      let menu = document.querySelector(".menu");

      profile.onclick = function () {
        menu.classList.toggle("active");
      };
    });
  }

  componentDidUpdate() {}

  render() {
    return (
      <>
        <Head />
        <header>
          <div className={this.props.class ? this.props.class : ""}>
            <div className="dash-header">
              <div className="containers">
                <NavLink to="/dashboard" className="hide-mobile">
                  <img
                    className="header-logo"
                    height="60px"
                    src={logodashheader}
                    alt={name}
                  />
                </NavLink>

                <div className="show-mobile menu-icon">
                  <a
                    href="#logout"
                    className="nav-desk-links active"
                    onClick={() => handleSubmit(this.props.self, "toggleNav")}
                  >
                    <img src={MenuIcon} height="30px" alt="MENU" />
                  </a>
                </div>

                <div className="nav-right">
                  <div className="sdt-switch hidden">
                    <input
                      type="checkbox"
                      className="drk-lte-switch-check light"
                      id="drk-lte-switch-check"
                      onClick={(e) => toggleDarkModeX()}
                    />
                    <label
                      for="drk-lte-switch-check"
                      className="drk-lte-switch-check-label"
                    >
                      <i className="fas fa-moon"></i>
                      <i className="fas fa-sun"></i>
                      <span className="ball"></span>
                    </label>
                  </div>

                  <div className="hide-mobile">
                    {getSession("contractor") == "0" ? (
                      <>
                        <NavLink to="/index" className="nav-desk-link hidden">
                          Home
                        </NavLink>
                      </>
                    ) : (
                      <>
                        <NavLink to="/index" className="nav-desk-link hidden">
                          Home
                        </NavLink>
                      </>
                    )}

                    <a
                      href="#beta"
                      className="nav-desk-link beta-btn"
                      target="_blank"
                    >
                      <span style={{ fontStyle: "italic", color: "red" }}>
                        {" "}
                        <b>BETA</b>{" "}
                      </span>
                    </a>

                    <a
                      href="https://upp.unifiedscholars.com"
                      className="nav-desk-link"
                      target="_blank"
                    >
                      Journals
                    </a>

                    <a
                      href="https://resources.unifiedscholars.com"
                      className="nav-desk-link"
                    >
                      Resources
                    </a>
                  </div>

                  <div className="hide-mobile hidden">
                    <a
                      href="javascript:void(0);"
                      className="nav-desk-link"
                      onClick={() => doPreLogout(this.props.self)}
                    >
                      Logout
                    </a>
                  </div>

                  <div class="profile">
                    <div class="user">
                      <h3 class="hidden">K.O</h3>
                    </div>
                    <i class="fa fa-sort-desc arr-down"></i>
                    <div class="img-box">
                      <img src={userIcon} alt={getSession("name")} />
                    </div>
                  </div>
                  <div class="menu">
                    <ul>
                      {(getSession("reviewer") && getSession("reviewer") > 0) ||
                      (getSession("editor") && getSession("editor") > 0) ? (
                        <>
                          <li>
                            <a href="/change/role">
                              <i class="fa fa-star"></i>&nbsp; Change Role
                            </a>
                          </li>
                          <li>
                            <a href="/change/field">
                              <i class="fa fa-certificate"></i>&nbsp; Change
                              Field
                            </a>
                          </li>
                        </>
                      ) : (
                        <></>
                      )}
                      <li>
                        <a href="/change/account">
                          <i class="fa fa-edit"></i>&nbsp; Update Account
                        </a>
                      </li>
                      <li>
                        <a href="/change/password">
                          <i class="fa fa-lock"></i>&nbsp; Change Password
                        </a>
                      </li>
                      <li>
                        <a
                          href="#logout"
                          onClick={() =>
                            handleSubmit(this.props.self, "logout")
                          }
                        >
                          <i class="fa fa-power-off"></i>&nbsp; Sign Out
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Header;
